import { createSlice } from "@reduxjs/toolkit";

import {
    getNotification,
    getNotificationsRedux,
    getNotificationsSummary,
    markAsReadBulk,
    putUnreadNotification,
} from "./notifications.asyncActions";

const initialState = {
    message: "",
    status: "idle",
    notificationUnread: "idle",
    notificationSingle: "idle",
    notifications: [],
    singleNotifications: {},
    isReqTrue: true,
    summary: {
        unread_count: 0,
        total_count: 0,
    },
};

export const notificationsSlice = createSlice({
    name: "notificationsState",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getNotificationsRedux.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getNotificationsRedux.fulfilled, (state, action) => {
                state.status = "success";
                state.notifications =
                    action.payload.data && action.payload.data;
            })
            .addCase(getNotificationsRedux.rejected, (state, action) => {
                state.status = "failed";
            })
            .addCase(putUnreadNotification.pending, (state) => {
                state.notificationUnread = "loading";
            })
            .addCase(putUnreadNotification.fulfilled, (state, action) => {
                state.notificationUnread = "success";
                state.isReqTrue = false;
            })
            .addCase(putUnreadNotification.rejected, (state, action) => {
                state.notificationUnread = "failed";
            })
            .addCase(getNotification.pending, (state) => {
                state.notificationSingle = "loading";
            })
            .addCase(getNotification.fulfilled, (state, action) => {
                state.notificationSingle = "success";
                state.singleNotifications =
                    action.payload.data && action.payload.data;
            })
            .addCase(getNotification.rejected, (state, action) => {
                state.notificationSingle = "failed";
            })
            .addCase(markAsReadBulk.pending, (state) => {
                state.markAsReadStatus = "loading";
            })
            .addCase(markAsReadBulk.fulfilled, (state) => {
                state.markAsReadStatus = "success";
            })
            .addCase(markAsReadBulk.rejected, (state) => {
                state.markAsReadStatus = "failed";
            })

            .addCase(getNotificationsSummary.pending, (state) => {
                state.summaryStatus = "loading";
            })
            .addCase(getNotificationsSummary.fulfilled, (state, action) => {
                const payload = action.payload?.data || {};
                state.summary.unread_count = payload.unread_count || 0;
                state.summary.total_count = payload.total_count || 0;
            })
            .addCase(getNotificationsSummary.rejected, (state) => {
                state.summary.unread_count = 0;
                state.summary.total_count = 0;
            });
    },
});

export default notificationsSlice.reducer;
